import React from 'react';
import NegotiationDetail from '../../Negotiation/detail';

const NegotiationSupplierDetail = () => (
  <NegotiationDetail
    mode='supplier'
    listPath='/apps-negotiation-supplier/view'
    endpoint='/negotiation/supplier'
    canStartTimer={false}
    breadcrumbLabel='Negotiation (Supplier)'
  />
);

export default NegotiationSupplierDetail;
